var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVideo),expression:"showVideo"}],staticClass:"douob-video-player"},[_c('video',{ref:"player",attrs:{"width":"216","autoplay":_vm.autoplay,"crossorigin":"anonymous"}},[_c('source',{attrs:{"src":_vm.src}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }